import Avatar from './Avatar'
import AvatarGroup from './AvatarGroup'
// @ts-ignore
Avatar.Group = AvatarGroup

export default Avatar
